import { Button, CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { enterCall, setConsent } from "../../../redux/actions/call";
import { setErrorMessage } from "../../../redux/actions/error";
import { parseHtmlContent } from "../../../utils/parseHtmlContent";
import {
  ConsentContent,
  ConsentDialog,
  ConsentDialogActions,
  ConsentDialogTitle,
  DialogContent,
} from "../../styled/ConsentModal";

const ConsentModal = ({ idRoom, consentText }) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.call.consent.loading);

  const handleAccept = () => {
    dispatch(setConsent(idRoom, true)).then(() => {
      dispatch(enterCall(idRoom));
    });
  };

  const handleReject = () => {
    dispatch(setConsent(idRoom, false)).then(() => {
      dispatch(
        setErrorMessage(
          "403",
          "La atención por videollamada no podrá efectuarse. Solicite un nuevo turno para su atención",
        ),
      );
    });
  };

  return (
    <ConsentDialog open disableEscapeKeyDown onClose={() => { }}>
      <ConsentDialogTitle>Consentimiento informado</ConsentDialogTitle>
      <DialogContent dividers>
        <ConsentContent>{parseHtmlContent(consentText)}</ConsentContent>
      </DialogContent>
      <ConsentDialogActions>
        <Button
          variant="outlined"
          color="error"
          onClick={handleReject}
          disabled={loading}>
          Rechazar
        </Button>
        <Button
          variant="contained"
          onClick={handleAccept}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}>
          Aceptar
        </Button>
      </ConsentDialogActions>
    </ConsentDialog>
  );
};

export default ConsentModal;
